import React from 'react';
import { View } from 'react-native-web';
import ColorBar from './ColorBar';
import { colorsName } from '../../../utils/DictionaryManagementUtils';
import RegularText from '../Text/RegularText';

//= ========================================================================

const ColorContainer = ({ globJSON, onConfigChanged, colorKey }) => (
  <View>
    <RegularText>{colorsName[colorKey]}</RegularText>
    <ColorBar
      globJSON={globJSON}
      updateColor={(colorId, newColor) => {
        globJSON.configurations.theme.colors[colorId] = newColor;
        onConfigChanged();
      }}
      colorId={colorKey}
    />
  </View>
);
export default ColorContainer;
